<template>
  <div
    class="filter-and-sort-nav-item"
    :class="{ desktop: $isDesktop }"
    :data-sctrack="`${String($route.name)}--FilterAndSortNavItem-${$isDesktop ? 'desktop' : 'mobile'}`"
    data-test="edit-filter-link"
  >
    <img src="./filter.svg" width="22" height="14" alt="" />
    <span class="text-wrapper">
      <translate v-if="$isDesktop" class="text">Filter</translate>
      <translate v-else class="text">Filter and sort...</translate>
      <slot />
    </span>
  </div>
</template>

<style scoped>
.filter-and-sort-nav-item {
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  text-decoration: none;
}

.text-wrapper {
  display: block;
  line-height: 1.2;
  text-decoration: none;
  text-align: left;
}

.text {
  color: var(--colour-text-default);
  font-weight: normal;
  text-decoration: none;
  display: block;
}

img {
  height: 1em;
  margin-right: 0.5em;
  width: auto;
}

/* desktop & tablet */
.desktop .text {
  color: white;
}

.desktop img {
  filter: brightness(0) grayscale(1) invert(1);
}
</style>
